<template>
    <div v-if="getData">
        <h2 class="headerName">
            {{ headerName }}
        </h2>
        <p><strong>This request has been <span :class="consultationStatus === 'approved' ? 'approved' : 'disapproved'">{{ consultationStatus.toUpperCase() }}</span>.</strong></p>
        <section>
            <h2 class="headerName">
                Details
            </h2>
            <ul style="margin-bottom: 15px;">
                <li><strong>Patient:</strong> {{ patientName }} (Birthdate: {{ birthdate }}, Gender: {{ sex }})</li>
                <li><strong>Medical Provider:</strong> {{ data.HOSP_NAME }}</li>
                <li><strong>Specialist:</strong> {{ data.DOCTOR ? `DR. ${data.DOCTOR}` : 'Any HMI-Accredited Doctor' }}</li>
                <li><strong>Date Issued:</strong> {{ approveDate }}</li>
                <li v-if="consultationStatus === 'approved'">
                    <strong>Valid Until:</strong> {{ validDate }}
                </li>
                <li><strong>Contract Number:</strong> {{ contractNo }}</li>
            </ul>
        </section>
        <template v-if="data.APPROVED">
            <h2 class="headerName">
                Authorization
            </h2>
            <p>The consultation and referral authorization slip for {{ patientName }} has been generated.</p>
            <p><strong>Note:</strong> Please print two copies of the authorization slip.</p>
            <PdfViewer
                v-if="pdfData"
                :pdf-data="pdfData"
            />
            <!-- <p>The member will also receive a copy via email ({{ data.EMAIL }}).</p> -->
        </template>
        <template v-else>
            <v-alert type="error">
                {{ data.REMA }}
            </v-alert>
        </template>
        <p><strong>Disclaimer:</strong> This approval for the referenced service or treatment is provisional. If further review determines the service/treatment isn't covered by the member's health plan, the patient may be responsible for any incurred costs.</p>
        <p class="hmiContact">
            <strong>For further inquiries:</strong> Please contact HMI directly at (02) 8811-1313, (02) 7752-0552, (02) 8865-3700, 0999-993-4895 and 0917-853-3705.
        </p>
    </div>
</template>

<script>
import { moment } from '../../../utils/date-shim'
import PdfViewer from './PdfViewer.vue'
export default {
    components: {
        PdfViewer
    },
    props: ['data'],
    data: ()=>({
        contractNo: null,
        validDate: null,
        approveDate: null,
        sex: null,
        birthdate: null,
        patientName: null,
        consultationStatus: null,
        headerName: null,
        consultationResult: null,
        pdfData: null,
        result: null
    }),
    computed: {
        getData() {
            if (this.data) this.fetchData(this.data)
            return true
        }
    },
    methods: {
        fetchPdf(pdf, fileName) {
            this.pdfData = pdf ? { url: pdf.data, type: pdf.type, fileName } : null
        },
        fetchData(data) {
            this.contractNo = `${data.MEMB_N}-${data.PROG_C}`
            this.validDate = moment(data.VALI_D).format('D MMMM YYYY')
            this.approveDate = moment(data.APPR_D).format('D MMMM YYYY')
            this.sex = data.SEX === 'F' ? 'FEMALE' : 'MALE'
            this.birthdate = moment(data.DOB).format('D MMMM YYYY')
            this.patientName = `${data.NAME}`
            this.consultationStatus = data.APPROVED ? 'approved' : 'disapproved'
            this.headerName = 'Out-Patient Consultation '
            data.APPROVED
                ? this.headerName += `Approved (OPPA No.: ${data.OPPAN_NO})`
                : this.headerName += 'Disapproved'
            const pdf = data && data.CRF_PDF ? data.CRF_PDF : null
            if (pdf) this.fetchPdf(pdf, `${data.MEMB_N}-${data.APPR_D}`)
            this.consultationResult = data
        }
    }
}
</script>

<style scoped>
.headerName {
    font-size: 20px;
}
.approved {
    color: #004d40;
}
.disapproved {
    color: rgb(133, 0, 0);
}
.hmiContact {
    margin-bottom: 40px;
}
</style>
